// libraries
import React, { useState, useContext } from "react";

// styles
import styles from "./styles.module.scss";

// components
import Media from "../Media/Media";
import Info from "../Info/Info";
import Done from "../Done/Content";

// context
import UserContext from "src/context/User";

const Content = () => {
  // states
  const [formData, setFormData] = useState({
    eventName: "",
    eventUrl: "",
    eventDescription: "",
    eventFile: null,
    eventStartDate: "",
    eventEndDate: "",
    eventCategory: null,
    eventLocation: null,
    eventStartTime: "",
    eventEndTime: "",
  });

  const [myEventData, setMyEventData] = useState(null);

  return (
    <>
      {!myEventData ? (
        <div className={styles.content}>
          <h3>Create Event</h3>
          <div className={styles.wrap}>
            <Media formData={formData} setFormData={setFormData} />
            <Info
              formData={formData}
              setFormData={setFormData}
              setMyEventData={setMyEventData}
            />
          </div>
        </div>
      ) : (
        <Done data={myEventData} />
      )}
    </>
  );
};

export default Content;
